import React from 'react'
import { Clock, MessageCircle, Trash2, FileText } from 'lucide-react'

export const CharacterCard = ({ character, onClick, favorability, daysTogether, lastChatTime, onDelete, onViewProfile }) => {
  const formatTime = (timestamp) => {
    if (!timestamp) return '从未聊天'
    const now = Date.now()
    const diff = now - timestamp
    const minutes = Math.floor(diff / 60000)
    const hours = Math.floor(diff / 3600000)
    const days = Math.floor(diff / 86400000)
    
    if (minutes < 1) return '刚刚'
    if (minutes < 60) return `${minutes}分钟前`
    if (hours < 24) return `${hours}小时前`
    if (days < 7) return `${days}天前`
    return new Date(timestamp).toLocaleDateString()
  }

  const getFavorabilityLevel = (fav) => {
    if (fav < 20) return { text: '陌生', color: 'text-gray-400' }
    if (fav < 50) return { text: '熟悉', color: 'text-blue-400' }
    if (fav < 80) return { text: '友好', color: 'text-green-400' }
    return { text: '亲密', color: 'text-pink-400' }
  }

  const level = getFavorabilityLevel(favorability || 0)

  return (
    <div
      className="group relative bg-dark-800 rounded-lg p-4 transition-all duration-200 border border-dark-600 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/10"
    >
      {/* 操作按钮组 */}
      <div className="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity z-10">
        <button
          onClick={(e) => {
            e.stopPropagation()
            onViewProfile?.(character)
          }}
          className="p-1.5 bg-dark-700 hover:bg-primary/20 text-dark-300 hover:text-primary rounded-lg transition-colors"
          title="查看档案"
        >
          <FileText size={14} />
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation()
            onDelete?.(character)
          }}
          className="p-1.5 bg-dark-700 hover:bg-red-500/20 text-dark-300 hover:text-red-400 rounded-lg transition-colors"
          title="删除角色"
        >
          <Trash2 size={14} />
        </button>
      </div>

      {/* 角色头像 */}
      <div onClick={onClick} className="cursor-pointer">
        <div className="relative mb-3">
        <div className="w-24 h-24 mx-auto rounded-full overflow-hidden bg-dark-700 border-2 border-dark-600 group-hover:border-primary/50 transition-colors">
          {character.avatar ? (
            <img
              src={character.avatar}
              alt={character.name}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(character.name)}&background=random&size=128`
              }}
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary to-secondary text-white text-2xl font-bold">
              {character.name?.charAt(0) || '?'}
            </div>
          )}
        </div>
        
        {/* 好感度等级标签 */}
        <div className={`absolute -bottom-1 left-1/2 transform -translate-x-1/2 px-2 py-0.5 rounded-full text-xs font-medium bg-dark-900 border ${level.color} border-current`}>
          {level.text}
        </div>
        </div>
      </div>

      {/* 角色信息 */}
      <div onClick={onClick} className="text-center cursor-pointer">
        <h3 className="text-lg font-semibold text-white mb-1 group-hover:text-primary transition-colors">
          {character.name}
        </h3>
        <p className="text-sm text-dark-300 line-clamp-2 mb-3 min-h-[2.5rem]">
          {character.description || '暂无描述'}
        </p>

        {/* 状态信息 */}
        <div className="flex items-center justify-between text-xs text-dark-400 mt-3 pt-3 border-t border-dark-600">
          <div className="flex items-center gap-1">
            <Clock size={12} />
            <span>{formatTime(lastChatTime)}</span>
          </div>
          {daysTogether !== undefined && daysTogether > 0 && (
            <div className="flex items-center gap-1">
              <MessageCircle size={12} />
              <span>第{daysTogether}天</span>
            </div>
          )}
        </div>

        {/* 好感度进度条 */}
        {favorability !== undefined && (
          <div className="mt-3">
            <div className="flex items-center justify-between text-xs text-dark-400 mb-1">
              <span>好感度</span>
              <span className={level.color}>{favorability}/100</span>
            </div>
            <div className="w-full h-1.5 bg-dark-700 rounded-full overflow-hidden">
              <div
                className={`h-full transition-all duration-300 ${
                  favorability < 20 ? 'bg-gray-500' :
                  favorability < 50 ? 'bg-blue-500' :
                  favorability < 80 ? 'bg-green-500' : 'bg-pink-500'
                }`}
                style={{ width: `${favorability}%` }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

